<template>
  <div class="alarmAnalysis"
    v-loading="$store.state.user.loadingState">
    <AnalysisHead @getActiveTime="getActiveTime" />
    <div class="analysis ashComWrap">
      <div class="comTitle">
        <h4>报警</h4>
      </div>
      <div class="comContentBox"
        style="display: flex; justify-content: space-between">
        <div class="box1 secondAshComWrap">
          <div class="comTitle">
            <h4>总览</h4>
          </div>
          <div class="comContentBox">
            <div class="topBox">
              <AnalysisOverview :overviewData="overviewData" />
            </div>
          </div>
        </div>
        <div class="box2 secondAshComWrap">
          <div class="comTitle">
            <h4>报警等级分析</h4>
          </div>
          <div class="comContentBox">
            <PublicEcharts :id="'box2'"
              :chartsData="gradeData"
              :type="'pieChart'" />
          </div>
        </div>
        <div class="box3 secondAshComWrap">
          <div class="comTitle">
            <h4>确认状态分析</h4>
          </div>
          <div class="comContentBox">
            <PublicEcharts :id="'box3'"
              :chartsData="stateData"
              :type="'ringChart'" />
          </div>
        </div>
        <div class="box4 secondAshComWrap">
          <div class="comTitle">
            <h4>转工单分析</h4>
          </div>
          <div class="comContentBox">
            <PublicEcharts :id="'box4'"
              :chartsData="orderData"
              :type="'ringChart'" />
          </div>
        </div>
      </div>
    </div>
    <AnalysisTwoChart :leftCharts="hoursCharts"
      :rightCharts="alarmTrend"
      :leftTitle="'24小时报警趋势'"
      :rightTitle="rightTitle" />
    <AnalysisTable :title="'报警详情表'"
      :tabHead="tabHead"
      :tableData="tableData"
      :excelTitle="excelTitle"
      :showDownload="judgeAuthority('shebei:alarmAnalysis:export')" />
  </div>
</template>

<script>
import api from "@/api";
import AnalysisHead from "@/components/fenxizujian/AnalysisHead";
import AnalysisTwoChart from "@/components/fenxizujian/AnalysisTwoChart";
import AnalysisTable from "@/components/fenxizujian/AnalysisTable";
import AnalysisOverview from "@/components/fenxizujian/AnalysisOverview";
import PublicEcharts from "@/components/PublicEcharts";
import { dateFtt, matchingAlarmLevel, judgeAuthority } from "@/assets/js/utils";
export default {
  components: {
    AnalysisHead,
    AnalysisTwoChart,
    AnalysisTable,
    AnalysisOverview,
    PublicEcharts,
  },
  data() {
    return {
      rightTitle: "",
      excelTitle: "",
      tabHead: [
        { label: "时间", prop: "time" },
        { label: "报警数量", prop: "alarmCount" },
        { label: "紧急", prop: "critical" },
        { label: "重要", prop: "major" },
        { label: "一般", prop: "minor" },
        { label: "转工单", prop: "toRepair" },
        { label: "未转工单", prop: "notToRepair" },
        { label: "已确认", prop: "confirmed" },
        { label: "未确认", prop: "notConfirm" },
      ],
      tableData: [],
      hoursCharts: {
        unit: "次",
        type: "bar",
        xData: [],
        dataArr: [],
      },
      alarmTrend: {
        unit: "次",
        type: "bar",
        xData: [],
        dataArr: [],
      },
      overviewData: {},
      gradeData: { dataArr: [] },
      stateData: {
        unit: "",
        dataArr: [],
      },
      orderData: { unit: "", dataArr: [] },
      timeValue: "",
    };
  },
  methods: {
    judgeAuthority,
    getActiveTime(val) {
      this.timeValue = val.timeValue;
      this.excelTitle = `报警分析-${this.timeValue ? this.timeValue : "全部"}`;
      this.$store.commit("SET_LOADING", true);
      if (val.type == "MONTH") {
        this.rightTitle = "每日报警趋势";
      } else if (val.type == "YEAR") {
        this.rightTitle = "每月报警趋势";
      } else {
        this.rightTitle = "每年报警趋势";
      }
      this.getAlarmData(val);
      this.getHourTrend(val);
      this.getRangeTrend(val);
      this.getTableData(val);
      setTimeout(() => {
        this.$store.commit("SET_LOADING", false);
      }, 1000);
    },
    async getAlarmData(data) {
      this.overviewData = {};
      this.stateData = {
        unit: "",
        dataArr: [],
      };
      this.orderData = {
        unit: "",
        dataArr: [],
      };
      this.gradeData.dataArr = [];
      let res = await api.getSAlarmAnalysis({
        type: data.type,
        data: data.timeValue,
      });
      if (res && res.data.code == 200) {
        let objData = res.data.data;
        this.overviewData = {
          title: "报警总数",
          num: objData.overview.find((v) => {
            return v.name == "报警总数";
          }).value,
          unit: "",
          yoy: objData.overview.find((v) => {
            return v.name == "同比";
          }).value,
          mom: objData.overview.find((v) => {
            return v.name == "环比";
          }).value,
        };
        this.stateData.dataArr = [
          {
            value: objData.confirmationStatusAnalysis.find((v) => {
              return v.name == "confirmed";
            }).value,
            name: "已确认",
          },
          {
            value: objData.confirmationStatusAnalysis.find((v) => {
              return v.name == "notConfirmed";
            }).value,
            name: "未确认",
          },
        ];
        this.stateData.unit = this.stateData.dataArr[0].unit ?? "";
        this.orderData.dataArr = [
          {
            value: objData.toRepairAnalysis.find((v) => {
              return v.name == "toRepaired";
            }).value,
            name: "已转工单",
          },
          {
            value: objData.toRepairAnalysis.find((v) => {
              return v.name == "notToRepair";
            }).value,
            name: "未转工单",
          },
        ];
        this.orderData.unit = this.orderData.dataArr[0].unit ?? "";
        let arr = objData.alarmLevelAnalysis.filter((v) => {
          return v.name == "CRITICAL" || v.name == "MAJOR" || v.name == "MINOR";
        });
        this.gradeData.dataArr = Array.from(arr).map((item) => ({
          name: matchingAlarmLevel(item.name),
          value: item.value,
        }));
      }
    },
    async getHourTrend(data) {
      this.hoursCharts.xData = [];
      this.hoursCharts.dataArr = [{ name: "24小时报警", data: [] }];
      let res = await api.getSAlarmHourTrend({
        type: data.type,
        data: data.timeValue,
      });
      if (res && res.data.code == 200) {
        res.data.data.map((v) => {
          this.hoursCharts.xData.push(v.name + "时");
          this.hoursCharts.dataArr[0].data.push(v.value);
        });
      }
    },
    async getRangeTrend(data) {
      this.alarmTrend.xData = [];
      this.alarmTrend.dataArr = [{ name: "报警数量", data: [] }];
      let res = await api.getSAlarmRangeTrend({
        type: data.type,
        data: data.timeValue,
      });
      if (res && res.data.code == 200) {
        res.data.data.map((v) => {
          this.alarmTrend.xData.push(
            data.type == "MONTH"
              ? dateFtt("dd日", new Date(v.ts))
              : data.type == "YEAR"
              ? dateFtt("MM月", new Date(v.ts))
              : dateFtt("yyyy年", new Date(v.ts))
          );
          this.alarmTrend.dataArr[0].data.push(v.value);
        });
      }
    },
    async getTableData(data) {
      this.tableData = [];
      let res = await api.getSAlarmAnalysisTable({
        type: data.type,
        data: data.timeValue,
      });
      if (res && res.data.code == 200) {
        this.tableData = res.data.data;
        this.tableData.map((v) => {
          v.time =
            data.type == "MONTH"
              ? dateFtt("yyyy-MM-dd", new Date(v.time))
              : data.type == "YEAR"
              ? dateFtt("yyyy-MM", new Date(v.time))
              : dateFtt("yyyy年", new Date(v.time));
        });
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.alarmAnalysis {
  width: 100%;
  overflow: auto;
  .analysis {
    height: 350px;
    width: $innerWidth;
    margin: 0 auto;
    .topBox {
      width: 85%;
      margin: 0 auto;
      height: 70%;
    }
    .box1 {
      width: 24%;
      height: 100%;
    }
    .box2,
    .box3,
    .box4 {
      width: 25%;
      height: 100%;
    }
  }
}
</style>